import React,{useState, useRef, useEffect, useLayoutEffect, useContext} from 'react'
import { NavLink, useLoaderData, useParams,useLocation, useNavigate } from "react-router-dom"
import { ThemeContext } from '../context/ThemeContext';
import { useDarkMode } from '../customhooks/ThemeHook';
import {SplitText} from "@cyriacbr/react-split-text"
//import TitleAnimated from './TitleAnimated'
import { BeakerIcon } from '@heroicons/react/24/solid'
import gsap from 'gsap'
//import { SplitText } from "gsap/SplitText"




function NewsView_1(props) {

  function findItemPerKey(slug,data){
    // the code you're looking for
    var slug = slug;
    var obj = data;
    // iterate over each element in the array
    for (var i = 0; i < obj.length; i++){
      // look for the entry with a matching `code` value
      if (obj[i].slug == slug){
         // we found it
         return (obj[i]);
      }
    }
  }
const location = useLocation();
const navigate = useNavigate();
const theme = useContext(ThemeContext);
const { id } = useParams();
//console.log(id);

  let dataItems = (useLoaderData());
  //console.log(dataItems);


  var bg_image = null;
  var _coef = 10;
  var _coefDefault = 10;
  var _coefMobile = 30;
  var maxScale = 0.4
  var maxScaleDefault = 0.5;
  var maxScaleMobile = 1.2;
  const smoothSc = useRef();
  const growRef = useRef();
  const featuredImgRef = useRef();

  const [dataAll, setDataAll] = useState();
  const [scrollValue, setScrollValue] = useState(0);
  const [featuredImage, setFeaturedImage] = useState();
  const [darkMode, setDarkMode] = useDarkMode(false);

  const  [pushOut,setPushOut] = useState();







useLayoutEffect(()=>{

  var _dataAll = findItemPerKey(id,dataItems.data);
  setDataAll(_dataAll);
  setFeaturedImage(_dataAll.image_thumb.url);

  },[location]);









  return (


    <div className="relative center items-center">

      <div id="news-page" className={props.transition}>


      <div style={{backgroundColor: '#000', backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover'}} className="relative background-cover h-[70vh] md:h-[100vh]">
        <h1 style={{fontSize:'200%'}} className="w-full text-center absolute top-[40vh] md:top-[70vh]">{dataAll ? dataAll.title :'...'}</h1>
      </div>

      <div className="px-8 lg:px-12 pt-12 md:pt-24">
        <div className="text-left text-white" dangerouslySetInnerHTML={{__html: dataAll ? dataAll.description :'...' }}/>

        <div style={{borderTop:'0.5px solid #000'}} className="text-center font-medium text-white mt-12 pt-12 ">

          <NavLink to={"/noticias"} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }}>{'+ Noticias' }
          </NavLink>
      </div>
</div>
  </div>
</div>
  )
}

export default NewsView_1
